import VendorCreateContainer from "./VendorCreateContainer";
export default VendorCreateContainer;
